import { Provider, Signal } from "@angular/core";
import {
    ATOM_SELECT_INPUT_ALL_SELECTED_LABEL,
    ATOM_SELECT_INPUT_CLEAR_LABEL,
    ATOM_SELECT_INPUT_PLACEHOLDER,
} from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "atom_select_input";

/**
 * Localizes the default `atom-select-input` trigger placeholder, all-selected
 * trigger copy, and clear footer that instances fall back to when they don't
 * bind `[placeholder]` / `[allSelectedLabel]` / `[clearLabel]` per usage.
 *
 * Loading caption and search placeholder live on
 * {@link provideAtomSelectPanelConfig} via `ATOM_SELECT_PANEL_CONFIG`
 * (`loadingCaption`, `searchPlaceholder`). The input has no separate search
 * token; omitted `[searchPlaceholder]` falls through to the panel config, then
 * `ATOM_SEARCH_INPUT_PLACEHOLDER`. `ATOM_SELECT_INPUT_LOADING_CAPTION` is
 * deprecated in the DS and is only the last fallback while panel
 * `loadingCaption` is still the library default.
 *
 * Tokens are `Signal<string>` and stay in sync on live language switches
 * (`reRenderOnLangChange: true`), same approach as
 * {@link provideAtomRichTextLabels}.
 */
export const provideAtomSelectInputLabels = (): Provider[] => [
    {
        provide: ATOM_SELECT_INPUT_PLACEHOLDER,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.placeholder`),
    },
    {
        provide: ATOM_SELECT_INPUT_CLEAR_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.clear_label`),
    },
    {
        provide: ATOM_SELECT_INPUT_ALL_SELECTED_LABEL,
        useFactory: (): Signal<string> =>
            translateSignal(`${BASE_KEY_PATH}.all_selected_label`),
    },
];
